import React, { useState, useEffect } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
import { User } from "lucide-react";
import "./mainHeader.css";
import logoc from "../../../assets/img/logo-color.png";
import logow from "../../../assets/img/logo-white.png"; 
import scriptIcon from "../../../assets/img/script.png"; 

export default function MainHeader() {
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);
  const [isMegaVisible, setIsMegaVisible] = useState(false);
  const [isAdminLoggedIn, setIsAdminLoggedIn] = useState(false);
  const [isHeaderHidden, setIsHeaderHidden] = useState(false);
  const navigate = useNavigate();

  // 페이지 전환 시 메가메뉴 닫기
  useEffect(() => {
    setIsMegaVisible(false);
  }, [location.pathname]);

  // 로그인 상태 확인
  useEffect(() => {
    const adminToken = localStorage.getItem("adminToken");
    setIsAdminLoggedIn(!!adminToken);
  }, []);

  // 스크롤 시 헤더 숨김 처리
  useEffect(() => {
    // 기존에는 일부 페이지에서 스크롤 시 헤더를 숨겼는데,
    // 현재 홈(레퍼런스 스타일) 포함 UX에서는 헤더가 항상 보이는 게 자연스럽습니다.
    // 필요하면 경로별로 다시 활성화할 수 있어요.
    setIsHeaderHidden(false);
  }, [location.pathname]);

  const menuItems = [
    {
      english: "About Us",
      korean: "회사소개",
      url: "/intro/about",
      submenu: [
        { korean: "회사개요", url: "/intro/about" },
        // { korean: "경영이념", url: "/intro/vision" }, // 임시 숨김 처리
        { korean: "조직도", url: "/intro/values" },
        { korean: "오시는길", url: "/intro/location" }
      ]
    },
    {
      english: "Services",
      korean: "사업분야",
      url: "/business",
      submenu: [
        { korean: "사업부 소개", url: "/business" },
        //{ korean: "서비스", url: "/business/services" },
        { korean: "프로세스", url: "/business/process" }
      ]
    },
    {
      english: "Community",
      korean: "커뮤니티",
      url: "/community",
      submenu: [
        { korean: "공지사항", url: "/notice" },
        { korean: "화물구직", url: "/news" },
        { korean: "소식", url: "/issue" }
      ]
    },
    {
      english: "Careers",
      korean: "채용공고",
      url: "/careers",
      submenu: [{ korean: "채용정보", url: "/careers" }]
    },
    {
      english: "",
      korean: "",
      url: "#",
      style: {
        marginLeft: "0px",
        visibility: "hidden",
        pointerEvents: "none"
      },
      submenu: []
    }
  ];

  const handleNavigation = (e, url, { closeMenu = false } = {}) => {
    // 채용공고는 새 창
    if (url === "/careers" || url.startsWith("/careers/")) {
      e.preventDefault();
      if (closeMenu) {
        setMenuOpen(false);
      }
      window.open(url, "_blank", "noopener,noreferrer");
      return;
    }
    if (closeMenu) {
      setMenuOpen(false);
    }
    navigate(url);
  };

  const handleMenuClick = (e, url) => {
    handleNavigation(e, url, { closeMenu: true });
  };

  const handleNavClick = (e, url) => {
    handleNavigation(e, url);
  };

  // 현재 경로에 따라 메뉴 활성화
  const isMenuActive = item => {
    if (item.url === "/careers") return false;

    if (item.url === "/intro/about") {
      return location.pathname.startsWith("/intro/");
    }

    if (item.url === "/business") {
      return location.pathname === "/business" || location.pathname.startsWith("/business/");
    }

    if (item.url === "/community") {
      return (
        location.pathname.startsWith("/community") ||
        location.pathname.startsWith("/notice") ||
        location.pathname.startsWith("/news") ||
        location.pathname.startsWith("/issue")
      );
    }

    return (
      location.pathname === item.url ||
      location.pathname.startsWith(item.url + "/")
    );
  };

  return (
    <>
      <header
        className={`plander-header ${
          isMegaVisible ? "has-mega-menu" : ""
        } ${
          isHeaderHidden ? "header-hidden" : ""
        }`}
      >
        <div className="header-inner">
          <Link to="/" className="header-logo">
            {/*항상 컬러 로고 고정 */}
            <img src={logoc} alt="로고" className="header-logo-img" />
          </Link>

          <div
            className="header-nav-wrapper"
            onMouseLeave={(e) => {
              // 마우스가 헤더 영역을 완전히 벗어났을 닫기
              const relatedTarget = e.relatedTarget;
              if (!relatedTarget || (relatedTarget instanceof Node && !e.currentTarget.contains(relatedTarget))) {
                setIsMegaVisible(false);
              }
            }}
          >
            <nav className="header-nav header-menu-grid">
              {menuItems.map((item, index) =>
                item.korean ? (
                  <div
                    key={index}
                    className="header-nav-item-wrapper"
                    onMouseEnter={() => {
                      if (item.submenu && item.submenu.length > 0) {
                        setIsMegaVisible(true);
                      }
                    }}
                    onMouseLeave={(e) => {
                      // 메인메뉴 오픈
                      const relatedTarget = e.relatedTarget;
                      const megaMenu = document.querySelector('.header-mega-menu');
                      if (megaMenu && relatedTarget instanceof Node && megaMenu.contains(relatedTarget)) {
                        return; 
                      }
                      // 메인메뉴 닫기
                      const navWrapper = e.currentTarget.closest('.header-nav-wrapper');
                      if (navWrapper && (!relatedTarget || !(relatedTarget instanceof Node) || !navWrapper.contains(relatedTarget))) {
                        setIsMegaVisible(false);
                      }
                    }}
                  >
                    <Link
                      to={item.url}
                      className={`header-nav-item ${isMenuActive(item) ? "active" : ""}`}
                      onClick={(e) => {
                        handleNavClick(e, item.url);
                        setIsMegaVisible(false); // 클릭 시 메뉴 닫기
                      }}
                    >
                      {item.korean}
                    </Link>
                  </div>
                ) : null
              )}
            </nav>

            <div
              className={`header-mega-menu ${isMegaVisible ? "visible" : "hidden"} ${
                isHeaderHidden ? "header-hidden" : ""
              }`}
              onMouseEnter={() => setIsMegaVisible(true)}
              onMouseLeave={(e) => {
                // 메가메뉴에서 벗어날 때
                const relatedTarget = e.relatedTarget;
                const navWrapper = document.querySelector('.header-nav-wrapper');
                if (!navWrapper || !relatedTarget || !(relatedTarget instanceof Node) || !navWrapper.contains(relatedTarget)) {
                  setIsMegaVisible(false);
                }
              }}
            >
              <div className="header-mega-menu-columns header-menu-grid">
                {menuItems.map((item, index) =>
                  item.submenu && item.submenu.length > 0 ? (
                    <div key={index} className="header-mega-menu-column">
                      {item.submenu.map((subItem, idx) => {
                        // /business는 정확히 일치할 때만 활성화 (하위 경로와 구분)
                        const isActive = subItem.url === "/business"
                          ? location.pathname === subItem.url
                          : location.pathname === subItem.url ||
                            location.pathname.startsWith(subItem.url + "/");
                        
                        return (
                        <Link
                          key={idx}
                          to={subItem.url}
                          className={`header-mega-menu-submenu-item ${
                            isActive ? "active" : ""
                          }`}
                          onClick={(e) => {
                            handleNavClick(e, subItem.url);
                            setIsMegaVisible(false); // 서브메뉴 클릭 시 메뉴 닫기
                          }}
                        >
                          {subItem.korean}
                        </Link>
                        );
                      })}
                    </div>
                  ) : null
                )}
              </div>
            </div>
          </div>

          {/* 오른쪽 */}
          <div className="header-right">
            {isAdminLoggedIn ? (
              <Link to="/admin" className="header-login-btn">
                <User size={20} className="header-login-icon" />
              </Link>
            ) : (
              <Link to="/login" className="header-login-btn">
                <User size={20} className="header-login-icon" />
              </Link>
            )}

            <button
              className={`header-menu-toggle ${menuOpen ? 'active' : ''}`}
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="메뉴 토글"
            >
              <span className="header-menu-text">MENU</span>
              <div className="header-menu-icon">
                <span className="header-bar"></span>
                <span className="header-bar"></span>
                <span className="header-bar"></span>
              </div>
            </button>
          </div>
        </div>
      </header>

      {menuOpen && (
        <div className="gakkun-overlay">
          <button
            className="gakkun-close"
            onClick={() => setMenuOpen(false)}
            aria-label="메뉴 닫기"
          >
            ×
          </button>
          <div className="gakkun-inner --single">
            <div className="gakkun-topbar">
              <Link to="/" onClick={() => setMenuOpen(false)}>
                <img src={logoc} alt="로고" className="gakkun-logo-img" />
              </Link>
            </div>
            <div className="gakkun-center">
              <nav className="business-card-layout">
                {menuItems.map((item, index) => (
                  <div key={index} className="business-card">
                    <Link
                      to={item.url}
                      className="business-card-link"
                      onClick={(e) => handleMenuClick(e, item.url)}
                    >
                      <h3 className="business-card-title">{item.korean}</h3>
                    </Link>
                    {item.submenu && (
                      <div className="business-card-submenu">
                        {item.submenu.map((subItem, subIndex) => (
                          <Link
                            key={subIndex}
                            to={subItem.url}
                            className="business-card-submenu-item"
                            onClick={(e) => handleMenuClick(e, subItem.url)}
                          >
                            {subItem.korean}
                          </Link>
                        ))}
                      </div>
                    )}
                  </div>
                ))}
              </nav>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
